module.exports = __webpack_public_path__ + "static/media/img_skill_validation_05.fd6c0621.png";